var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.lista),function(item){return _c('v-list-item',{key:item.codigo,attrs:{"color":"primary"},on:{"click":function($event){return _vm.chamaAcao(item)}}},[_c('v-list-item-content',{staticClass:"tutorial"},[_vm._v(" "+_vm._s(item.title)+" ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }